export class Restabfalltonne {
    tonnen_id : number;
    einrichtungs_id: number;
    volumen_in_litern : number;
    leerungen_pro_jahr : number;
 }